"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "agnone": {
    "cd4a485d": [{
      "hkey": "65a4dc72",
      "slug": "villa-canale",
      "name": "Villa Canale",
      "primary": true,
      "skipSearch": false
    }],
    "villacanale": [{
      "hkey": "65a4dc72",
      "slug": "villa-canale",
      "name": "Villa Canale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;